module.exports = __webpack_public_path__ + "img/rope-cleaning-farrer-sunshade.1dcc189d.jpg";